import React, { useMemo } from 'react';

const GRID_SIZE = 21;

function hashValue(value) {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) >>> 0;
  }
  return hash;
}

function buildQrMatrix(value) {
  const seed = hashValue(value);
  const matrix = [];

  for (let row = 0; row < GRID_SIZE; row += 1) {
    const currentRow = [];
    for (let column = 0; column < GRID_SIZE; column += 1) {
      const inTopLeftFinder = row < 7 && column < 7;
      const inTopRightFinder = row < 7 && column >= GRID_SIZE - 7;
      const inBottomLeftFinder = row >= GRID_SIZE - 7 && column < 7;

      if (inTopLeftFinder || inTopRightFinder || inBottomLeftFinder) {
        const localRow = row % 7;
        const localColumn = column % 7;
        const isOuterRing = localRow === 0 || localRow === 6 || localColumn === 0 || localColumn === 6;
        const isInnerCore = localRow >= 2 && localRow <= 4 && localColumn >= 2 && localColumn <= 4;
        currentRow.push(isOuterRing || isInnerCore);
        continue;
      }

      const bit = (seed + row * 17 + column * 31 + row * column * 7) % 2 === 0;
      const keepClearTimingRow = row === 6;
      const keepClearTimingColumn = column === 6;
      currentRow.push((keepClearTimingRow || keepClearTimingColumn) ? (row + column) % 2 === 0 : bit);
    }
    matrix.push(currentRow);
  }

  return matrix;
}

export default function ReservationQrCode({ value, label = 'Reservation QR placeholder' }) {
  const matrix = useMemo(() => buildQrMatrix(value), [value]);
  const cellSize = 6;
  const quietZone = 4;
  const viewBoxSize = (GRID_SIZE + quietZone * 2) * cellSize;

  return (
    <svg
      role="img"
      aria-label={`${label} for ${value}`}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      width="168"
      height="168"
      style={{
        display: 'block',
        width: '168px',
        height: '168px',
        background: 'white',
        borderRadius: '16px',
        border: '1px solid rgba(26, 39, 99, 0.12)',
        padding: '12px',
      }}
    >
      <rect width={viewBoxSize} height={viewBoxSize} fill="#ffffff" />
      {matrix.map((row, rowIndex) =>
        row.map((filled, columnIndex) => (
          filled ? (
            <rect
              key={`${rowIndex}-${columnIndex}`}
              x={(columnIndex + quietZone) * cellSize}
              y={(rowIndex + quietZone) * cellSize}
              width={cellSize}
              height={cellSize}
              rx="1"
              fill="#121b49"
            />
          ) : null
        )),
      )}
    </svg>
  );
}
